import { useState, useEffect } from "react";
import { Modal, Form, Input, message, Select } from "antd";
import axios from "axios";
import { useAuth0 } from "../../react-auth0-spa";
import { useAppContext } from "../../context";
import config from "../../api_config.json";
import updateFeatureMutation from "./queries/updateFeatureMutation";

const PLAN_OPTIONS = [
  { label: "Base", value: "base" },
  { label: "Verificato", value: "verified" },
  { label: "Premium", value: "premium" },
];

const EditFeatureModal = ({ visible, onCancel, onUpdate, feature }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const { getTokenSilently } = useAuth0();
  const { isProd } = useAppContext();
  const env = isProd ? "prod" : "dev";

  useEffect(() => {
    if (feature && visible) {
      form.setFieldsValue({
        name: feature.name,
        label: feature.label,
        description: feature.description,
        plans: (feature.plans || []).map((p) => (typeof p === "string" ? p : p.value)),
      });
    }
  }, [feature, visible, form]);

  const handleUpdate = async () => {
    try {
      const values = await form.validateFields();

      setLoading(true);

      const token = await getTokenSilently();
      const graphqlUrl = `${config.baseUrl[env]}/graphql?raw=true`;

      const fields = {
        name: values.name,
        label: values.label || "",
        description: values.description || "",
        plans: values.plans || [],
      };

      await axios.post(
        graphqlUrl,
        {
          query: updateFeatureMutation,
          variables: { id: feature.objectId, fields },
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      message.success("Feature aggiornata con successo");
      onUpdate();
    } catch (error) {
      if (error.errorFields) {
        return;
      }
      console.error("Error updating feature:", error);
      message.error("Errore durante l'aggiornamento della feature");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="Modifica Feature"
      open={visible}
      onOk={handleUpdate}
      onCancel={handleCancel}
      okText="Salva"
      cancelText="Annulla"
      confirmLoading={loading}
      width={500}
      maskClosable={false}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Nome (chiave)"
          name="name"
          rules={[{ required: true, message: "Il nome e' obbligatorio" }]}
        >
          <Input placeholder="es: directory, bio, gallery, shop" />
        </Form.Item>

        <Form.Item label="Label" name="label">
          <Input placeholder="es: Presenza in directory" />
        </Form.Item>

        <Form.Item label="Descrizione" name="description">
          <Input.TextArea
            placeholder="Descrizione della feature"
            rows={3}
          />
        </Form.Item>

        <Form.Item label="Piani inclusi" name="plans">
          <Select
            mode="multiple"
            placeholder="Seleziona i piani che includono questa feature"
            options={PLAN_OPTIONS}
            allowClear
          />
        </Form.Item>

      </Form>
    </Modal>
  );
};

export default EditFeatureModal;
